/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.0
 */

import { borderColorSeparate, FreshAsphalt, FreshAsphalt50 } from './palette';

export const pageAuthBorderColor = borderColorSeparate;
export const pageAuthTextColor = FreshAsphalt;
export const pageAuthTextColorSecondary = FreshAsphalt50;
